var settings = require('ofs/settings');

var trackConvertro = function(eventType) {
    if (settings.tracking.gactive && settings.tracking.convertroTracking) {
        $CVO = window.$CVO || [];
        $CVO.push([ "trackEvent", {
            type: eventType,
            id: eventType + '-{cvoid}-{r}',
            amount:'1'
        }]);

        if (settings.user.isAuthenticated) {
            $CVO.push(['trackUser', {
                id: settings.user.id
            }]);
        }
    } else {
        console.log('Convertro tracking disabled', eventType);
    }
};

module.exports = trackConvertro;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/tracking/convertro.js
 **/